export const CREATE_NEW_SCRIPT = 'CREATE_NEW_SCRIPT'
export const DELETE_SCRIPT = 'DELETE_SCRIPT'
export const CREATE_NEW_SCRIPT_ITEM = 'CREATE_NEW_SCRIPT_ITEM'
export const EDIT_SCRIPT_ITEM = 'EDIT_SCRIPT_ITEM'
export const DELETE_SCRIPT_ITEM = 'DELETE_SCRIPT_ITEM'